import { APP_SETTINGS_STORAGE_KEY, APP_VISUAL_STYLES } from '../constants';
import type { AppVisualStyle } from '../types';

const DEFAULT_VISUAL_STYLE: AppVisualStyle = 'soft_tactile';
const STYLESHEET_ID = 'design-language-stylesheet';

function hrefForVisualStyle(style: AppVisualStyle): string {
  return APP_VISUAL_STYLES.find((item) => item.style === style)?.href ?? APP_VISUAL_STYLES[0].href;
}

function resolveVisualStyle(value: unknown): AppVisualStyle {
  if (value === 'comic_board') return 'comic_board';
  if (value === 'tactile_instrument') return 'tactile_instrument';
  return value === 'paper_panel' ? 'paper_panel' : DEFAULT_VISUAL_STYLE;
}

export function readStoredVisualStyle(): AppVisualStyle {
  try {
    const raw = localStorage.getItem(APP_SETTINGS_STORAGE_KEY);
    if (!raw) return DEFAULT_VISUAL_STYLE;
    const parsed = JSON.parse(raw) as { visualStyle?: unknown };
    return resolveVisualStyle(parsed.visualStyle);
  } catch {
    return DEFAULT_VISUAL_STYLE;
  }
}

export function applyVisualStyleStylesheet(style: AppVisualStyle): void {
  if (typeof document === 'undefined') return;
  const href = hrefForVisualStyle(style);
  let link = document.getElementById(STYLESHEET_ID) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.id = STYLESHEET_ID;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }
  if (link.getAttribute('href') !== href) {
    link.setAttribute('href', href);
  }
}
